module.exports = __webpack_public_path__ + "img/9.70c52839.png";